/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Funnel_Account_Login_SubInputs */

const en_funnel_account_login_sub = /** @type {(inputs: Funnel_Account_Login_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your trial starts on the account you sign in with.`)
};

const es_funnel_account_login_sub = /** @type {(inputs: Funnel_Account_Login_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu prueba empezará en la cuenta con la que inicies sesión.`)
};

/**
* | output |
* | --- |
* | "Your trial starts on the account you sign in with." |
*
* @param {Funnel_Account_Login_SubInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const funnel_account_login_sub = /** @type {((inputs?: Funnel_Account_Login_SubInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Funnel_Account_Login_SubInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_funnel_account_login_sub(inputs)
	return en_funnel_account_login_sub(inputs)
});